// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2sYw4","title":"ClientCherryInfo_title__3Q66F","itemText":"ClientCherryInfo_itemText__2XMRJ"};